import React from 'react';
import {
	GridActionsCellItem,
	GridActionsCellItemProps,
	GridRowParams,
} from '@mui/x-data-grid-premium';
import { useGlobalization } from '@Translations/useGlobalization';
import { Map } from '@mui/icons-material';

export const MenuCell = (
	params: GridRowParams,
	isFindAssetsEnabled: boolean,
	onFindAsset: (assetId: string) => void,
): React.ReactElement<GridActionsCellItemProps>[] => {
	const { t } = useGlobalization();
	const result = new Array<React.ReactElement<GridActionsCellItemProps>>();

	if (isFindAssetsEnabled) {
		result.push(
			<GridActionsCellItem
				key={'find'}
				icon={<Map />}
				label={t('Find Asset in Network')}
				onClick={() => {
					onFindAsset(params.row.ASSET_ID);
				}}
				showInMenu
			/>,
		);
	}

	return result;
};
